import React, { useState, useEffect } from "react";
import axios from "axios";

const VendorList = () => {
  const [vendors, setVendors] = useState([]);
  const [vendorBookings, setVendorBookings] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const response = await axios.get(
          "https://vrpmpro.com/api/vendor/getallvendors"
        );
        const sortedVendors = response.data.vendors.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setVendors(sortedVendors);

        // Fetch bookings for each vendor
        const bookingPromises = sortedVendors.map((vendor) =>
          axios
            .get(
              `https://vrpmpro.com/api/user/bookings/vendor/${vendor._id}`
            )
            .then((res) => {
              // Process bookings to categorize by status
              const bookingsByStatus = res.data.bookings.reduce(
                (acc, booking) => {
                  if (booking.status === "completed") {
                    acc.completed += 1;
                  } else if (booking.status === "cancelled") {
                    acc.cancelled += 1;
                  } else {
                    // Assume all other statuses mean "assigned"
                    acc.assigned += 1;
                  }
                  return acc;
                },
                { completed: 0, cancelled: 0, assigned: 0 } // Default structure
              );

              return {
                vendorId: vendor._id,
                bookingsByStatus,
              };
            })
            .catch(() => ({
              vendorId: vendor._id,
              bookingsByStatus: { completed: 0, cancelled: 0, assigned: 0 },
            }))
        );

        const bookingsData = await Promise.all(bookingPromises);
        const bookingsMap = bookingsData.reduce((acc, item) => {
          acc[item.vendorId] = item.bookingsByStatus;
          return acc;
        }, {});

        setVendorBookings(bookingsMap);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch vendor data");
        setLoading(false);
        console.error("Error fetching vendor data:", err);
        alert("Error fetching vendor data");
      }
    };

    fetchVendors();
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center mt-5">
        <p className="text-danger">{error}</p>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Vendors List</h2>
      {vendors.length > 0 ? (
        <div className="row">
          {vendors.map((vendor) => (
            <div key={vendor._id} className="col-md-4 mb-3">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">{vendor.vendorName}</h5>
                  <p className="card-text">
                    <strong>Email:</strong> {vendor.vendorEmail}
                  </p>
                  <p className="card-text">
                    <strong>Contact Number:</strong> {vendor.VendorcontactNumber}
                  </p>
                  <p className="card-text">
                    <strong>Registered On:</strong>{" "}
                    {new Date(vendor.createdAt).toLocaleDateString()}
                  </p>
                  <p className="card-text">
                    <strong>Vehicle Name:</strong> {vendor.vehicleName || "N/A"}
                  </p>
                  <p className="card-text">
                    <strong>Vehicle Number:</strong>{" "}
                    {vendor.vehicleNumber || "N/A"}
                  </p>
                  <p className="card-text">
                    <strong>Total Bookings Assigned:</strong>{" "}
                    {vendorBookings[vendor._id]?.assigned || 0}
                  </p>
                  <p className="card-text">
                    <strong>Total Bookings Completed:</strong>{" "}
                    {vendorBookings[vendor._id]?.completed || 0}
                  </p>
                  <p className="card-text">
                    <strong>Total Bookings Cancelled:</strong>{" "}
                    {vendorBookings[vendor._id]?.cancelled || 0}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No vendors found</p>
      )}
    </div>
  );
};

export default VendorList;
